import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider
} from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as deTitles } from '../i18n/de.titles.json';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { SOFTLINE_PERMISSION_HARDWARE_MANAGEMENT } from './hardware-management.shared';
import { hardwareRoutes } from './hardware-management.routes';

export function provideHardwareManagementModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'hardwareManagement',
        title: '#HARDWARE_MANAGEMENT.APP',
        icon: 'fa-regular fa-server',
        route: '/hardware-management',
        permission: SOFTLINE_PERMISSION_HARDWARE_MANAGEMENT,
        group: getModuleGroupByName('Technik'),
      },
      withSoftAppsModuleRoutes({ app: hardwareRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/softline/hardware',
        description: 'Verwaltung der Hardware und Geräte bei Softline.',
      })
    ),
  ];
}

export const hardwareProviders: EnvironmentProviders[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'hardwareManagement',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#HARDWARE_MANAGEMENT.APP',
      icon: 'fa-regular fa-server',
      route: '/hardware-management',
      permission: SOFTLINE_PERMISSION_HARDWARE_MANAGEMENT,
      group: getModuleGroupByName('Technik'),
    });
  }),
];
